export class AuctionDetailButtonConfiguration{


    constructor(public label : string,public description? : string, public price? : number, public time? : number, public cssClass? : string, public buttonLabel? : string){}

    public static create = (label : string) => new AuctionDetailButtonConfiguration(label);

    setPrice(value : number) : AuctionDetailButtonConfiguration{

        this.price = value;
        return this;

    }

    setTime(value : number) : AuctionDetailButtonConfiguration{

        this.time = value;
        return this;

    }

    setCssClass(value : string) : AuctionDetailButtonConfiguration{

        this.cssClass = value;
        return this;

    }

    setButtonLabel(value : string) : AuctionDetailButtonConfiguration{

        this.buttonLabel = value;
        return this;

    }

    setDescription(value : string) : AuctionDetailButtonConfiguration{

        this.description = value;
        return this;

    }
}
